import { useEffect, useState } from "react"

import { ACCESS_TOKEN } from "../constants";

function createHeaders(){
  const headers = new Headers({
    "Content-Type": "application/json",
  });

  if (localStorage.getItem(ACCESS_TOKEN)) {
    headers.append(
      "Authorization",
      "Bearer " + localStorage.getItem(ACCESS_TOKEN)
    );
  }
  return headers;
}

export default function useFetch(options){

    const [data,setData] = useState(null)
    const [error,setError] = useState(null)
    const [loading,setLoading] = useState(false)

    useEffect(() => {

      const fetchAPI = async () => {
        try {
          let headers= createHeaders();
          const defaults = { headers: headers };
          let optionsAux= Object.assign({}, defaults, options); 
          const response = await fetch(optionsAux.url, optionsAux);
          const data = await response.json();
          setData(data);
        } catch (error) {
            setError(error);
        } finally {
            setLoading(false);
        }
      };

      fetchAPI();
        
    }, [options.url])

    return { data, error, loading }
}